import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import enCommon from './locales/en/common.json';
import enLanding from './locales/en/landing.json';
import enLpSalonPain from './locales/en/lp-salon-pain.json';
import enLpSalonOutcome from './locales/en/lp-salon-outcome.json';
import enLpSalonBooking from './locales/en/lp-salon-booking.json';
import enSeoSalonBookingSoftware from './locales/en/seo-salon-booking-software.json';
import enSeoHairstylistBookingApp from './locales/en/seo-hairstylist-booking-app.json';
import enSeoBeautyProfessionalBooking from './locales/en/seo-beauty-professional-booking.json';
import enSeoSalonClientManagement from './locales/en/seo-salon-client-management.json';
import enSeoStopBookingClientsThroughDms from './locales/en/seo-stop-booking-clients-through-dms.json';
import enSeoSalonAppointmentReminders from './locales/en/seo-salon-appointment-reminders.json';
import enSeoSalonClientRetention from './locales/en/seo-salon-client-retention.json';
import enSeoOnlineBookingPageForHairstylists from './locales/en/seo-online-booking-page-for-hairstylists.json';
import enSeoSalonNoShowPrevention from './locales/en/seo-salon-no-show-prevention.json';
import enSeoSalonSoftwareForSoloStylists from './locales/en/seo-salon-software-for-solo-stylists.json';
import enToolsFormulaScaler from './locales/en/tools-formula-scaler.json';
import enToolsSalonPriceList from './locales/en/tools-salon-price-list.json';
import enTools from './locales/en/tools.json';
import esCommon from './locales/es-MX/common.json';
import esLanding from './locales/es-MX/landing.json';
import esToolsFormulaScaler from './locales/es-MX/tools-formula-scaler.json';
import esToolsSalonPriceList from './locales/es-MX/tools-salon-price-list.json';
import esTools from './locales/es-MX/tools.json';

// 'tools-floor-plan' is deliberately NOT statically imported here — it's
// registered lazily in tools/loaders.ts alongside FloorPlanPage's own dynamic
// import, so its ~9KB/locale JSON isn't shipped on every marketing page's
// initial JS (see apps/web/scripts/check-public-bundles.mjs budget).

const english = {
  common: enCommon,
  landing: enLanding,
  'lp-salon-pain': enLpSalonPain,
  'lp-salon-outcome': enLpSalonOutcome,
  'lp-salon-booking': enLpSalonBooking,
  'seo-salon-booking-software': enSeoSalonBookingSoftware,
  'seo-hairstylist-booking-app': enSeoHairstylistBookingApp,
  'seo-beauty-professional-booking': enSeoBeautyProfessionalBooking,
  'seo-salon-client-management': enSeoSalonClientManagement,
  'seo-stop-booking-clients-through-dms': enSeoStopBookingClientsThroughDms,
  'seo-salon-appointment-reminders': enSeoSalonAppointmentReminders,
  'seo-salon-client-retention': enSeoSalonClientRetention,
  'seo-online-booking-page-for-hairstylists': enSeoOnlineBookingPageForHairstylists,
  'seo-salon-no-show-prevention': enSeoSalonNoShowPrevention,
  'seo-salon-software-for-solo-stylists': enSeoSalonSoftwareForSoloStylists,
  'tools-formula-scaler': enToolsFormulaScaler,
  'tools-salon-price-list': enToolsSalonPriceList,
  tools: enTools,
};

export const marketingI18nReady = i18next
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    supportedLngs: ['en', 'es-MX'],
    defaultNS: 'common',
    resources: {
      en: english,
      'es-MX': {
        ...english,
        common: esCommon,
        landing: esLanding,
        'tools-formula-scaler': esToolsFormulaScaler,
        'tools-salon-price-list': esToolsSalonPriceList,
        tools: esTools,
      },
    },
    detection: {
      order: ['htmlTag'],
    },
    interpolation: { escapeValue: false },
  });

export default i18next;
